export const r2pEnum = Object.freeze({
    loadModeEnum: {
        before: 1,
        rest: 2,
        start: 3,
        hover: 4,
    },
    LoadStatusEnum: {
        start: 0,
        load: 1,
        clear: 2
    }
})

